export default __webpack_public_path__ + "static/media/footer-logo.4c27b823.png";